<app-dialog-wrapper [isClosing]="isClosing" (animationend)="onAnimationEnd()">

  <div class="w-full p-2 flex-1">
    <h2 class="text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins">Excédent détecté</h2>
    <p class="text-gray-700 mb-4">
      Le paiement total dépasse de
      <span class="text-red-600">{{ data.overpayment | number: data.currencyFormat.decimalsString }} {{data.currencyFormat.currencySymbol}}</span>.
    </p>
    <p class="text-sm text-gray-800 font-semibold">Que souhaitez-vous en faire ?</p>

    <div class="flex justify-center gap-4 flex-wrap mt-4">
      <button mat-button class="w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full"
        (click)="onClose('refund')">
        Rembourser
      </button>
      <button mat-button class="w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full"
        (click)="onClose('tip')">
        Laisser en pourboire
      </button>
      <button mat-button class="w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full"
        (click)="onClose('credit')">
        Créditer
      </button>
    </div>
  </div>
</app-dialog-wrapper>
